/**
 * ReportSelector — report type picker cards.
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { REPORTS } from '../../hooks/reports/reportConstants';
import { FileOutput } from 'lucide-react';

const ReportSelector = ({ activeReport, onSelect, isFarm }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
    {REPORTS.filter(r => r.id !== 'custom').map(r => (
      <Card
        key={r.id}
        className={`cursor-pointer transition-[box-shadow,outline] hover:shadow-md ${activeReport === r.id ? 'ring-2 ring-primary' : ''}`}
        onClick={() => onSelect(r.id)}
      >
        <CardContent className="p-4 text-center">
          <r.icon className={`w-6 h-6 mx-auto mb-1 ${activeReport === r.id ? 'text-primary' : 'text-muted-foreground'}`} />
          <p className="text-xs font-medium">{r.label}</p>
        </CardContent>
      </Card>
    ))}
    {isFarm && (
      <Card
        className={`cursor-pointer transition-[box-shadow,outline] hover:shadow-md ${activeReport === 'departure-form' ? 'ring-2 ring-primary' : ''}`}
        onClick={() => onSelect('departure-form')}
      >
        <CardContent className="p-4 text-center">
          <FileOutput className={`w-6 h-6 mx-auto mb-1 ${activeReport === 'departure-form' ? 'text-primary' : 'text-muted-foreground'}`} />
          <p className="text-xs font-medium">Departure Form</p>
        </CardContent>
      </Card>
    )}
    <Card
      className={`cursor-pointer transition-[box-shadow,outline] hover:shadow-md ${activeReport === 'custom' ? 'ring-2 ring-primary' : ''}`}
      onClick={() => onSelect('custom')}
    >
      <CardContent className="p-4 text-center">
        {(() => { const R = REPORTS.find(r => r.id === 'custom'); return R ? <R.icon className={`w-6 h-6 mx-auto mb-1 ${activeReport === 'custom' ? 'text-primary' : 'text-muted-foreground'}`} /> : null; })()}
        <p className="text-xs font-medium">Custom Report</p>
      </CardContent>
    </Card>
  </div>
);

export default ReportSelector;
